
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { TranslationHandler } from '@/mixins/translation-handler'
import { SpotifyGateMessages, SpotifyGateMode, SpotifyGateStatus } from '@/types'
import { ThemeState } from '@/store/modules/theme'
import cms from '@/cms'

@Component
export default class SpotifyGate extends Mixins(TranslationHandler) {
  @Prop({ default: false }) isBackgroundShown!: boolean
  @Prop({ default: false }) isPositionCenter!: boolean
  @Prop({ default: false }) isAlignmentCenter!: boolean

  @Getter campaignId!: number
  @Getter campaignSpotifyGateMode!: SpotifyGateMode
  @Getter campaignSpotifyGateMessages!: SpotifyGateMessages
  @Getter spotifyGateStatus!: SpotifyGateStatus
  @Getter themePrimaryColor!: string
  @Getter themeBackgroundColor!: string
  @Getter themeText!: ThemeState['text']
  @Getter themeRounded!: 'medium' | 'full' | 'none'

  borderRadius = {
    medium: 'rounded-lg',
    none: '',
    full: 'rounded-3xl',
  }

  get translations () {
    return {
      heading: this.$tx(this.campaignSpotifyGateMessages, 'heading'),
      body: this.$tx(this.campaignSpotifyGateMessages, 'body'),
      connectCta: this.$tx(this.campaignSpotifyGateMessages, 'connectCta') || 'Continue with Spotify',
      skipCta: this.$tx(this.campaignSpotifyGateMessages, 'skipCta') || 'Continue without Spotify',
      error: this.$tx(this.campaignSpotifyGateMessages, 'error') || "We couldn't connect to Spotify. Please try again.",
      retryCta: this.$tx(this.campaignSpotifyGateMessages, 'retryCta') || 'Retry connection',
    }
  }

  get isOptional () {
    return this.campaignSpotifyGateMode === 'optional'
  }

  get isError () {
    return this.spotifyGateStatus === 'error'
  }

  get isAuthorizing () {
    return this.spotifyGateStatus === 'authorizing'
  }

  onSpotifyLogin () {
    if (this.isAuthorizing) return

    this.$store.commit('SET_SPOTIFY_GATE_STATUS', 'authorizing')
    cms.tracking.trackCustomer('login_start', {
      method: 'spotify',
      journey: 'spotify_gate',
    })

    try {
      cms.account.loginSpotify()
    } catch (error) {
      this.$store.commit('SET_SPOTIFY_GATE_STATUS', 'error')
      cms.tracking.trackCustomer('login_fail', {
        method: 'spotify',
        journey: 'spotify_gate',
        error_message: 'client_error',
      })
    }
  }

  onSpotifySkip () {
    if (!this.isOptional) return

    window.sessionStorage.setItem(`spotify-connect-skipped:${this.campaignId}`, 'true')
    this.$store.commit('SET_SPOTIFY_GATE_STATUS', 'skipped')
    cms.tracking.trackCustomer('login_skip', {
      method: 'spotify',
      journey: 'spotify_gate',
    })
    this.$router.replace({ name: 'Home-linked' })
  }
}
